import { createActions, type Actions } from "./actions.ts";
import { createClient, type Client } from "./client.ts";
import type { KeyValue } from "./prefs.ts";

function deviceStorage(): KeyValue | undefined {
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
}

function soon(): (flush: () => void) => void {
  const channel = new MessageChannel();
  const queue: (() => void)[] = [];
  channel.port1.onmessage = () => queue.shift()?.();
  return (flush) => {
    if (document.hidden) return void requestAnimationFrame(flush);
    queue.push(flush);
    channel.port2.postMessage(null);
  };
}

export function browserClient(): { readonly client: Client; readonly actions: Actions } {
  const client = createClient({
    fetch: (url, init) => fetch(url, init),
    apiVersion: NABLA_API,
    now: Date.now,
    after: (ms, run) => {
      const id = setTimeout(run, ms);
      return () => clearTimeout(id);
    },
    schedule: soon(),
    randomKey: () => crypto.randomUUID(),
    storage: deviceStorage(),
  });
  addEventListener("pagehide", () => client.flush());
  document.addEventListener("visibilitychange", () => document.visibilityState === "hidden" && client.flush());
  return { client, actions: createActions(client) };
}
